var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInactiveDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    opacity: 0.3,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.999992C0 0.447712 0.447712 0 0.999992 0H7.99993C8.55221 0 8.99993 0.447712 8.99993 0.999992V7.99993C8.99993 8.55221 8.55221 8.99993 7.99993 8.99993H0.999992C0.447712 8.99993 0 8.55221 0 7.99993V0.999992ZM1.99998 1.99998V6.99994H6.99994V1.99998H1.99998Z",
    fill: "#F4F7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0.999992C11 0.447712 11.4477 0 12 0H18.9999C19.5522 0 19.9999 0.447712 19.9999 0.999992V7.99993C19.9999 8.55221 19.5522 8.99993 18.9999 8.99993H12C11.4477 8.99993 11 8.55221 11 7.99993V0.999992ZM13 1.99998V6.99994H17.9999V1.99998H13Z",
    fill: "#F4F7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 12C11 11.4477 11.4477 11 12 11H18.9999C19.5522 11 19.9999 11.4477 19.9999 12V18.9999C19.9999 19.5522 19.5522 19.9999 18.9999 19.9999H12C11.4477 19.9999 11 19.5522 11 18.9999V12ZM13 13V17.9999H17.9999V13H13Z",
    fill: "#F4F7FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 11.4477 0.447712 11 0.999992 11H7.99993C8.55221 11 8.99993 11.4477 8.99993 12V18.9999C8.99993 19.5522 8.55221 19.9999 7.99993 19.9999H0.999992C0.447712 19.9999 0 19.5522 0 18.9999V12ZM1.99998 13V17.9999H6.99994V13H1.99998Z",
    fill: "#F4F7FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveDashboard);
export default __webpack_public_path__ + "static/media/inactiveDashboard.dbe1a2504ceacf228dd702e715f7c10d.svg";
export { ForwardRef as ReactComponent };